import { DndProvider } from "react-dnd"
import "./admin.css"
import { HTML5Backend } from "react-dnd-html5-backend"
import Topbar from "../../components/topbar/Topbar"
import { useState } from "react";
import AdminLeftbar from "../../components/adminLeftbar/AdminLeftbar";
import AdminMiddle from "../../components/adminMiddle/AdminMiddle";

export default function Admin({ socketio, connectionState, selectedMission, isMissionDragging }) {
  const [isSidebar, setIsSidebar] = useState(true);
  return (
    <>
    <DndProvider backend={HTML5Backend}>
        <Topbar connectionState={connectionState} selectedMission={selectedMission} isMissionDragging={isMissionDragging}/>
        <div className="mainContainer">
          <AdminLeftbar isSidebar={isSidebar} />
          <AdminMiddle />
        </div>
    </DndProvider>
    </>
    )
}
